import { useNavigate } from 'react-router-dom';
import { Suspense, lazy, useEffect, useState } from "react"
import { UseAuth } from "../auth/AuthContext"
import NavUser from "../components/System/NavUser"
import { getLogout, redirectWelcomeCashier } from 'src/helpers/mixins';
import SidebarCashier, { MenuListedCashier } from 'src/components/Cashier/Shared/CashierSidebar';
import logoISF from "src/assets/images/logo/BannerISFsmall.png"
import LoadingScreen from 'src/components/LoadingScreen';
import { useAppStateContext } from 'src/auth/AppStateContext';
import { IoClose } from 'react-icons/io5';
import OfflineAlert from 'src/components/Shared/OfflineAlert';
import LastConnection from 'src/components/Shared/LastConnection';
import VersionCheck from 'src/components/Shared/VersionCheck';
const WelcomeSetName = lazy(() => import("src/components/Welcome/WelcomeSetName"));
interface LayoutOptions {
  children: React.ReactElement
}
const LayoutCashier = ({ children }: LayoutOptions) => {
  const { isAuthenticated, user } = UseAuth()
  const {cashierWelcome,
    fetchCashierWelcome,
    fetchCashierConfig,
    setShowMenuMovil,
    showMenuMovil
  } = useAppStateContext()
  const navigate = useNavigate();
  const [showMenu, setShowMenu] = useState<boolean>(false)
  useEffect(() => {
    if (!isAuthenticated) {
      navigate('/');
    }
    // eslint-disable-next-line
  }, [isAuthenticated])

  useEffect(() => {
    if((user?.id?.length || 0 )> 0 && (user?.role || '' ) ==='cashier' ){
      fetchCashierConfig(user?.id || '')
      fetchCashierWelcome(user?.id || '')
 
    }
  }, [user])

  useEffect(() => {
    if(user && cashierWelcome){
      if(redirectWelcomeCashier(cashierWelcome,user)!=''){
        navigate(redirectWelcomeCashier(cashierWelcome,user))
      }
    }
  }, [user,cashierWelcome])
  
  useEffect(() => {
    // 60 seg * 10 = 600 seg => 10 min
    const TIME_INACTIVO = 2400
    let n = TIME_INACTIVO
    const interval = setInterval(() => {
      window.onmousemove = function () {
        n = TIME_INACTIVO
      }
      n--
      if (n < 0) { 
        getLogout()
        return () => clearInterval(interval);
      }
    }, 1000)
    return () => clearInterval(interval);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div className='bg-gray-100'>
      {/*<div>
        {(user?.role || "user") === "admin" ? <ChatAdmin /> : <ChatClient />}
      </div>*/}
        <OfflineAlert />
        <VersionCheck />
        {isAuthenticated && <LastConnection />}
        <NavUser />
        
        <div className="w-full md:w-11/12 md:mx-auto flex flex-row md:gap-4 flex-grow overflow-hidden mt-5">
      <div className='w-full hidden md:block md:w-72 md:relative' style={{zIndex:""}}>
        <SidebarCashier />
        </div>
        <div className="w-full   flex flex-row md:gap-4 flex-grow overflow-hidden">
          <div className="w-full mb-64 px-4 mx-auto max-w-100">
            {!showMenuMovil && 
              <>
          
                {children}
              </>
            }
          </div>

          {showMenuMovil &&   
            <div className='bg-nav-movil-cashier-user flex flex-col justify-center items-center pt-2'>
              <div className='w-full flex items-center z-20 justify-between  px-4 border-b border-stone-300 fixed top-0 bg-white'>
                <img src={logoISF} 
                className='w-36'
                alt="ISF" 
                />
                <div className='cursor-pointer' onClick={() => setShowMenuMovil(false)}>
                  <IoClose size={45} />
                </div>
              </div>
              <div className='listed-in-movil w-full md:w-fit z-10 relative'>
                <MenuListedCashier close={() => setShowMenuMovil(false)} />
              </div>
            </div>
          }
        </div>
      </div>
      {
      user?.fullname?.toLowerCase().includes(user?.email?.toLowerCase()) && (
        <Suspense fallback={<LoadingScreen />}>
          <WelcomeSetName />
        </Suspense>
      )}
  </div>
  )
}

export default LayoutCashier